import { render, staticRenderFns } from "./permission-desc.vue?vue&type=template&id=56aa2bb1&scoped=true"
import script from "./permission-desc.vue?vue&type=script&lang=js"
export * from "./permission-desc.vue?vue&type=script&lang=js"
import style0 from "./permission-desc.vue?vue&type=style&index=0&id=56aa2bb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aa2bb1",
  null
  
)

export default component.exports